var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoToDateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.62987 4.99739H10.9338M3.30063 1.00007V2.30413M3.30063 2.30413L10.9697 2.30399M3.30063 2.30413C2.02993 2.30413 0.999941 3.33766 1 4.61273L1.00036 12.3081C1.00042 13.5831 2.03047 14.6166 3.30109 14.6166H10.9702C12.2409 14.6166 13.271 13.5829 13.2709 12.3079L13.2706 4.61251C13.2705 3.33753 12.2404 2.30399 10.9697 2.30399M10.9697 1V2.30399M5.60193 11.9232V7.30597L4.06811 8.46028M9.81995 11.9232V7.30597L8.28612 8.46028",
    stroke: "#272727",
    strokeWidth: 0.961928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToDateIcon);
export default __webpack_public_path__ + "static/media/GoToDateIcon.b31f839a3cee6e9f856507f1305f882c.svg";
export { ForwardRef as ReactComponent };